var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 30a16.095 16.095 0 0 0-5.31.92l-7.86-25.4A4.99 4.99 0 0 0 28.05 2h-4.1a4.99 4.99 0 0 0-4.78 3.52L7.26 44H7a5.002 5.002 0 0 0-5 5v2a1.003 1.003 0 0 0 1 1h28.18A15.995 15.995 0 1 0 46 30Zm1 6.51 4.59-3.34a14.146 14.146 0 0 1 4.88 3.56l-1.75 5.39-2.84.92L47 39.49Zm-2 0v2.98l-4.88 3.55-2.84-.92-1.75-5.39a14.146 14.146 0 0 1 4.88-3.56ZM21.08 6.11A2.994 2.994 0 0 1 23.95 4h4.1a2.994 2.994 0 0 1 2.87 2.11L32.43 11H19.57ZM16.78 20h18.44l2.47 8H14.31Zm13.36 24H9.36l2.16-7h21.26a15.922 15.922 0 0 0-2.64 7Zm3.81 9.09a13.862 13.862 0 0 1-1.88-5.73l4.59-3.34 2.83.92 1.83 5.87-1.7 2.28Zm15.07 6.57A13.704 13.704 0 0 1 46 60a13.546 13.546 0 0 1-3.01-.34l-1.76-5.39 1.7-2.27h6.14l1.7 2.27Zm3.36-6.57-1.7-2.28 1.83-5.87 2.83-.92 4.59 3.34a13.862 13.862 0 0 1-1.88 5.73Z",
    "data-name": "28-Training"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.339c577cb73efb7500ec91dff7e0db44.svg";
export { ForwardRef as ReactComponent };